import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { KPI } from './layout/Sidebar/__generated__/Sidebar_User.graphql'
dayjs.extend(relativeTime)

export const formatEnumString = (enumString?: string | null) => {
  if (enumString == null) {
    return ''
  }
  const token = enumString.trim().toUpperCase().replace(/\s+/g, '_')
  if (token === 'DOMINANT_COLOR') {
    return 'Primary Color'
  }
  return enumString
    .split('_')
    .map((it) => it.charAt(0).toUpperCase() + it.slice(1).toLowerCase())
    .join(' ')
}

/** Maps display label type (from formatEnumString) back to a GraphQL LabelType token for API variables. */
export const labelTypeToGraphqlEnum = (labelType?: string | null): string => {
  if (labelType == null || labelType === '') return ''
  const upper = labelType.trim().toUpperCase()
  if (upper.startsWith('HOOK')) return 'HOOK_TEXT'
  if (upper === 'PRIMARY COLOR' || upper === 'PRIMARY_COLOR') return 'DOMINANT_COLOR'
  return upper.replace(/\s+/g, '_')
}

export const toHumanReadableDate = (dateString: string) => {
  const date = dayjs(dateString)
  const now = dayjs()
  if (now.diff(date, 'day', true) < 1) {
    const returnString = date.fromNow()
    return `${returnString.charAt(0).toUpperCase()}${returnString.slice(1)}`
  }
  if (now.diff(date, 'week', true) < 1) {
    return `Last ${date.format('dddd')} at ${date.format('h:mm a')}`
  }
  return date.format('M/D/YYYY h:mm a')
}

export const removeMetricFromFilter = ( adKPI: KPI | null, filter: any[]): any[] => {
  if (!adKPI || !Array.isArray(filter)) {
    return filter;
  }

  const adKPItoMetricMap: Record<string, string> = {
    'WEBSITE_PURCHASES': 'WebsitePurchases',
    'SPEND': 'AmountSpent',
    'COST_PER_PURCHASE': 'CostPerWebsitePurchase',
    'COST_PER_TOTAL_PURCHASE': 'CostPerPurchase',
  };

  const metricToRemove = adKPItoMetricMap[adKPI];

  if (metricToRemove) {
    return filter.filter((item) => {
      if (typeof item === 'string') {
        return item !== metricToRemove;
      }
      if (item.fieldKey) {
        return item.fieldKey !== metricToRemove;
      }
      return true;
    });
  }

  return filter;
};


export const toApiDateString = (date: Date) => date.toISOString().split('T')[0]
